import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ButtonModule } from '@hglobal/common';

import { TranslateInPipe } from '../../../../pipes/translate-in.pipe';
import { CtaDefinition, CtaSurface } from '../../cta.models';

export type CtaListLayout = 'column' | 'wrap';

@Component({
  selector: 'fb-cta-list',
  templateUrl: './cta-list.component.html',
  styleUrl: './cta-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, TranslateInPipe],
})
export class CtaListComponent {
  readonly ctas = input.required<CtaDefinition[]>();

  /** Disables every CTA — used while a CTA-triggered bot request is in flight. */
  readonly disabled = input<boolean>(false);

  /**
   * Layout of the chips: a full-width vertical stack (`column`, used by the
   * page FAB) or content-sized chips that wrap across rows (`wrap`, used inside
   * the chat popup).
   */
  readonly layout = input<CtaListLayout>('column');
  readonly surface = input<CtaSurface>();

  readonly ctaSelected = output<CtaDefinition>();
}
